exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.c-btn-wrap[data-v-02ff13d4] {\n  margin-top: 30px;\n}\n.store-detail-area__block--right--details[data-v-02ff13d4] {\n  white-space: pre-line;\n}\n", ""]);

// exports
